import React from "react";
import { MessageCircle, Smartphone, Mail } from "lucide-react";

const OPTIONS = [
  { key: "whatsapp", label: "WhatsApp", icon: MessageCircle, tone: "text-[#25D366] border-[#25D366]/30 bg-[#25D366]/10" },
  { key: "sms", label: "SMS", icon: Smartphone, tone: "text-blue-600 border-blue-200 bg-blue-50" },
  { key: "email", label: "Email", icon: Mail, tone: "text-amber-700 border-amber-200 bg-amber-50" },
];

export default function ChannelPicker({ value = ["whatsapp"], onChange, testidPrefix = "channel" }) {
  const toggle = (key) => {
    const has = value.includes(key);
    let next = has ? value.filter(k => k !== key) : [...value, key];
    if (next.length === 0) next = [key]; // never empty
    onChange(next);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {OPTIONS.map(({ key, label, icon: Icon, tone }) => {
        const on = value.includes(key);
        return (
          <button
            key={key}
            type="button"
            onClick={() => toggle(key)}
            data-testid={`${testidPrefix}-${key}`}
            className={`inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-lg border transition-colors ${
              on ? tone : "border-border bg-card text-muted-foreground hover:border-border"
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
